export const SALUDO = `Hello,`

export const NAME = `my name is Cristian Ospina.`

export const DESCRIPCION = `I'm a software developer.`

export const NAMEBUTTON = `Portfolio`
